/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of DateField.
 * @typedef {Object} DateFieldType
 *
 * @typedef {QuestionFormFieldType & DateFieldType} DateFieldExtendType
 */

/**
 * Represents a date form field.
 * @class
 */
export class DateField extends QuestionFormField {}
